import { defaultProps } from "helpers/common";
import { Typography, TypographyProps } from "@mui/material";

function AppLinkText(props: TypographyProps) {
    const typographyProps = defaultProps(props, {
        component: "span",
        sx: {
            cursor: "pointer",
            textDecoration: "underline",
            "&:hover": {
                textDecoration: "none",
            },
        },
    });

    return <Typography {...typographyProps} />;
}

export default AppLinkText;
